/**
 * rem 基准设置：1rem = 视口宽度 / 10
 *
 * 设计稿宽度 1440px 时，1rem = 144px，
 * 与 postcss.config.js 里的 rootValue: 144 对应，
 * 这样 CSS 里直接写设计稿像素值即可自动等比换算。
 *
 * 注意：项目自带的 lib-flexible 会把宽度上限锁在 540px（移动端方案），
 * 桌面端官网用它会导致大屏严重缩小，所以这里自己实现。
 */
const DESIGN_WIDTH = 1440; // 设计稿宽度
const MIN_WIDTH = 0; // 最小缩放宽度，0 表示不限制；想让小屏不再继续缩小可改成 768

function setRemUnit() {
  const clientWidth =
    document.documentElement.clientWidth || window.innerWidth || DESIGN_WIDTH;

  // 上限锁定设计稿宽度：屏幕 > 1440 时按 1:1 展示，不再等比放大（避免图片拉伸模糊）
  let width = Math.min(clientWidth, DESIGN_WIDTH);
  // 下限保护：避免极小屏（如手机）把整站缩到看不清
  if (MIN_WIDTH && width < MIN_WIDTH) width = MIN_WIDTH;

  document.documentElement.style.fontSize = width / 10 + "px";
}

setRemUnit();

window.addEventListener("resize", setRemUnit, false);
// 前进/后退从缓存恢复页面时（bfcache）重新计算
window.addEventListener(
  "pageshow",
  function (e) {
    if (e.persisted) setRemUnit();
  },
  false
);

export default setRemUnit;
